var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPercent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.30021 4.40016C6.30021 4.89724 5.89724 5.30021 5.40016 5.30021C4.90307 5.30021 4.5001 4.89724 4.5001 4.40016C4.5001 3.90307 4.90307 3.5001 5.40016 3.5001C5.89724 3.5001 6.30021 3.90307 6.30021 4.40016ZM7.80031 4.40016C7.80031 5.72573 6.72573 6.80031 5.40016 6.80031C4.07459 6.80031 3 5.72573 3 4.40016C3 3.07459 4.07459 2 5.40016 2C6.72573 2 7.80031 3.07459 7.80031 4.40016ZM14.2962 2.70456C14.7356 3.14393 14.7356 3.85628 14.2962 4.29565L5.29562 13.2963C4.85625 13.7356 4.14389 13.7356 3.70453 13.2963C3.26516 12.8569 3.26516 12.1445 3.70453 11.7052L12.7051 2.70456C13.1445 2.26519 13.8569 2.26519 14.2962 2.70456ZM12.5999 12.5007C13.097 12.5007 13.4999 12.0977 13.4999 11.6006C13.4999 11.1035 13.097 10.7006 12.5999 10.7006C12.1028 10.7006 11.6998 11.1035 11.6998 11.6006C11.6998 12.0977 12.1028 12.5007 12.5999 12.5007ZM12.5999 14.0008C13.9254 14.0008 15 12.9262 15 11.6006C15 10.2751 13.9254 9.20048 12.5999 9.20048C11.2743 9.20048 10.1997 10.2751 10.1997 11.6006C10.1997 12.9262 11.2743 14.0008 12.5999 14.0008Z",
    fill: "#5D5D67"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercent);
export default __webpack_public_path__ + "static/media/percent.97a2c45dbd2b107780d671f7ecd6bf68.svg";
export { ForwardRef as ReactComponent };